
function signup(state = {
  register: [],
  fetching: false,
  fetched: false,
  error: null,
  year_fetched:false,
  sendOTP: null,
  sendOTPError: null
}, action){
  switch (action.type) {
      case 'SIGNUP_USER_REJECTED':{
        return {
          ...state,
          fetching: false,
          error: action.payload,
          register:[],
        }
      }
      case 'SIGNUP_USER_FULFILLED':{
        return{
          ...state,
          fetching: false,
          fetched: true,
          error:false,
          register: action.payload,
        }
      }
      case 'RESET_SIGNUP':{
        return{
          ...state,
          fetched: false,
          register:[],
        }
      }
      case 'GET_YEAR_FULFILLED':{
      return{
        ...state,
        year_fetched:true,
        year: action.payload,
      }
    }
    case 'GET_YEAR_REJECTED':{
      return {
        ...state,
        year_fetched:false,
        error: action.payload,
      }
    }
    
    case 'SEND_OTP_FULFILLED':{
      return {
        ...state,
        sendOTP: action.payload,
        sendOTPError:null,
      }
    }
    case 'SEND_OTP_REJECTED':{
      return{
        ...state,
        sendOTP: null,
        sendOTPError:action.payload,
      }
    }  
      default:break
   }
   return state;
}
export default signup;



/** WEBPACK FOOTER **
 ** ./src/reducers/signup.js
 **/